export const SKILLS_EVALUATIONS = "/api/folder-groups/:param/skills-evaluations"
export const SKILLS_EVALUATION = "/api/folder-groups/:param/skills-evaluations/:skillsEvaluationParam"

export const GENERATE_GLOBAL_RESULT = "/api/folder-groups/:param/skills-evaluations/generate"

export const SKILLS_EVALUATION_DEACTIVATE = "/api/folder-groups/:param/skills-evaluations/:skillsEvaluationParam/deactivate"
export const SKILLS_EVALUATION_ACTIVATE = "/api/folder-groups/:param/skills-evaluations/:skillsEvaluationParam/activate"
